export default () => ({
    closeButton: {
        position: 'absolute',
        top: '15px',
        right: '24px',
        backgroundColor: 'transparent',
    },
    customButton: {
        borderRadius: '9px',
        maxWidth: '30px',
        maxHeight: '30px',
        minWidth: '30px',
        minHeight: '30px',
        marginTop: '0px',
        fontSize: 9,
        textTransform: 'none',
        color: '#3d4241',
        marginLeft: '0px',
        border: '1px solid #ffffff',
        '&:hover': {
          backgroundColor: '#ffffff',
          color: 'white',
        },
    },
    modalContainer: {
        position: 'relative',
        margin: '0 auto',
        marginTop: '6%',
        width: '90%',
        maxWidth: '730px',
        maxHeight: '90vh',
        background: '#FFFFFF',
        border: '1px solid #505050',
        borderRadius: '40px',
        overflow: 'hidden',
        outline: 0,
    },
    modalHeader: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderBottom: '3px solid #8A7F7C',
        padding: '16px',
        paddingBottom: '8px',
        marginBottom: '16px',
    },
    modalTitle: {
        margin: '0px',
        fontSize: '19px',
        fontFamily: 'Poppins',
        fontWeight: '400',
    },
    modalBody: {
        padding: '34px',
        paddingTop: '0px',
        paddingBottom: '10px',
        fontFamily: 'Nunito',
        fontSize: '16px',
        lineHeight: '17px',
        fontWeight: '400',
        '& ul': {
            paddingLeft: '20px',
        },
        '& li': {
            fontFamily: 'Nunito',
            fontSize: '16px',
            lineHeight: '17px',
            paddingBottom: '16px',
        },
        '& li:last-child': {
            paddingBottom: '0px',
        }
    },
});